import React, { useEffect } from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { Form, Input, Button, notification } from 'antd';
import Cookies from 'js-cookie';
import Head from '../../components/Head';
import './auth.css';

function SignIn() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const signedIn = Cookies.get('token') ? true : false;

  const handleCredentialResponse = (response) => {
    handleGoogleSignIn(response.credential);
  };

  useEffect(() => {
    const initGoogle = () => {
      if (!window.google?.accounts?.id) return false;
      window.google.accounts.id.initialize({
        client_id: '493483959965-rspkljm6ergq7bth5t2g4aac1psd7cvj.apps.googleusercontent.com',
        callback: handleCredentialResponse,
      });
      window.google.accounts.id.renderButton(document.getElementById('divGbox'), {
        text: 'continue_with',
        shape: 'rectangular',
        width: '220px',
      });
      return true;
    };
    if (!initGoogle()) {
      const interval = setInterval(() => {
        if (initGoogle()) clearInterval(interval);
      }, 200);
      return () => clearInterval(interval);
    }
  }, []);

  useEffect(() => {
    if (signedIn) navigate('/dashboard');
  }, [signedIn, navigate]);

  const handleLogin = async (values) => {
    try {
      const response = await fetch(global.SERVIP + '/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ email: values.username.trim(), password: values.password }),
      });
      const data = await response.json();
      if (data.ok) {
        Cookies.set('token', data.token, { expires: 15, path: '/' });
        Cookies.set('subuser', data.subuser ? true : false, { expires: 15, path: '/' });
        navigate('/dashboard');
      } else {
        notification.error({ message: data.message });
      }
    } catch {
      notification.error({ message: 'Login failed. Please try again.' });
    }
  };

  const handleGoogleSignIn = async (credential) => {
    try {
      const response = await fetch(global.SERVIP + '/auth/google-sign-in', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ credential }),
      });
      if (!response.ok) throw new Error();
      const data = await response.json();
      if (data.ok) {
        Cookies.set('token', data.token, { expires: 15, path: '/' });
        Cookies.set('subuser', data.subuser ? true : false, { expires: 15, path: '/' });
        navigate('/dashboard');
      } else {
        notification.error({ message: data.message });
        window.google.accounts.id.prompt();
      }
    } catch {
      console.error('Google sign-in failed');
    }
  };

  return (
    <div className="auth-page">
      <Head title="Sign In" />

      {/* Left panel */}
      <div className="auth-left">
        <Link to="/" className="auth-left-logo">
          <img src="/assets/img/logo/logo2.png" alt="TextLink" />
          <span>TextLink</span>
        </Link>

        <div className="auth-left-content">
          <h2 className="auth-left-tagline">
            Send SMS from your own phone.
            <span>No middlemen. No markups.</span>
          </h2>
          <p className="auth-left-desc">
            Turn any Android device into an SMS gateway. Skip A2P registration, connect to GoHighLevel, and start messaging at true carrier rates.
          </p>
        </div>

        <div className="auth-left-stats">
          <div className="auth-stat">
            <div className="auth-stat-value">10M+</div>
            <div className="auth-stat-label">Messages sent</div>
          </div>
          <div className="auth-stat">
            <div className="auth-stat-value">1,000+</div>
            <div className="auth-stat-label">Active users</div>
          </div>
          <div className="auth-stat">
            <div className="auth-stat-value">95%</div>
            <div className="auth-stat-label">Cheaper than Twilio</div>
          </div>
        </div>
      </div>

      {/* Right panel */}
      <div className="auth-right">
        <div className="auth-form-container">
          <h1 className="auth-heading">Welcome back</h1>
          <p className="auth-subheading">Sign in to your account to continue</p>

          <div className="auth-google" id="divGbox"></div>
          <div className="auth-divider"><span>or</span></div>

          <Form name="login" form={form} onFinish={handleLogin} layout="vertical">
            <Form.Item
              name="username"
              label="Email Address"
              rules={[{ required: true, message: 'Please enter your email' }]}
            >
              <Input placeholder="name@example.com" autoCapitalize="none" />
            </Form.Item>

            <Form.Item
              name="password"
              label="Password"
              rules={[{ required: true, message: 'Please enter your password' }]}
            >
              <Input.Password placeholder="Password" />
            </Form.Item>

            <NavLink className="auth-forgot" to="/forgot-password">
              Forgot password?
            </NavLink>

            <Form.Item>
              <Button htmlType="submit" type="primary" size="large" style={{ width: '100%' }}>
                Sign In
              </Button>
            </Form.Item>
          </Form>

          <p className="auth-footer">
            Don't have an account? <a href="/signup">Sign up</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default SignIn;
